<template>
  <section>
    <div :id="`seating-time-${uid}`" class="flex items-center mb-2">
      <div :class="`${sharedStyle} ${timeStyle}`">
        <input
          type="time"
          class="pl-2 px-4 font-sans text-base leading-8 bg-surface-primary w-full rounded-sm"
          v-model="seatingTime.time24"
        />
      </div>
      <div :class="`${sharedStyle} ${guestsStyle}`">
        <input
          type="number"
          class="pl-2 font-sans text-base leading-8 w-full bg-surface-primary rounded-sm"
          v-model="seatingTime.maximum_guests"
        />
      </div>
      <template v-if="deleteAlwaysAllowed || !seatingTimeReservation">
        <span
          :id="`seating-time-${uid}-delete`"
          class="text-xs text-fg-secondary hover:cursor-pointer seatingTimeDelete"
          @click="deleteSeatingTime(seatingTime)"
        >
          Delete
        </span>
      </template>
      <template v-else>
        <span
          class="text-xs text-fg-secondary cursor-pointer seatingTimeCannotDelete"
          @click="tooltipSeatingTimeDialog = true"
        >
          Delete
        </span>
      </template>
    </div>
    <SlotModal
      :display="tooltipSeatingTimeDialog"
      id="cannot-delete-seating-time-dialog"
      @close="tooltipSeatingTimeDialog = false"
    >
      <template #header>Cannot Delete</template>
      <template #default>
        <div class="font-sans text-base">
          This seating time cannot be deleted because it has one or more Reservations. Please
          <span class="text-fg-link-primary cursor-pointer" @click="reservationRoute"
            >change the Reservations</span
          >
          to a different seating time and then retry.
        </div>
        <div class="flex justify-center mt-8">
          <ButtonDefault
            label="OK"
            id="tooltip-seatingtime-dialog"
            @click="tooltipSeatingTimeDialog = false"
          />
        </div>
      </template>
    </SlotModal>
  </section>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { PropType, defineComponent } from 'vue'

import ButtonDefault from '@/common/components/atoms/ButtonDefault.vue'
import SlotModal from '@/common/components/organisms/SlotModal.vue'
import { FormSeatingTime } from '@/models'
import { PERFORMANCE_ROUTE_NAMES } from '@/modules/performance/constants/PerformanceRouteConstants'
import { useReservationStore } from '@/modules/reservation/stores/ReservationStore'

import { ReservationRead } from '@generated/types'

export default defineComponent({
  name: 'SeatingTimeForm',
  components: {
    ButtonDefault,
    SlotModal,
  },
  props: {
    seatingTime: { type: Object as PropType<FormSeatingTime>, required: true },
    uid: { type: String, required: true },
    sharedStyle: { type: String, required: true },
    timeStyle: { type: String, required: true },
    guestsStyle: { type: String, required: true },
    deleteAlwaysAllowed: { type: Boolean, required: false, default: false },
  },
  emits: {
    // eslint-disable-next-line no-unused-vars
    delete: (_SeatingTime: FormSeatingTime) => true,
  },
  data() {
    return {
      tooltipSeatingTimeDialog: false,
    }
  },
  computed: {
    ...mapState(useReservationStore, ['reservations']),

    seatingTimeReservation(): ReservationRead {
      return this.reservations.find(reservation => reservation.seating_time === this.seatingTime.id)
    },
  },
  methods: {
    deleteSeatingTime(seatingTime) {
      this.$emit('delete', seatingTime)
    },

    async reservationRoute() {
      await this.$router.push({
        name: PERFORMANCE_ROUTE_NAMES.RESERVATION_LIST,
        params: {
          performanceId: this.seatingTimeReservation.performance_id.toString(),
        },
      })
    },
  },
})
</script>
